var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPower = function SvgPower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgPower",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgPower{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "power_1_",
    className: "svgPower svgBase svgHover svgSelect",
    d: "M0.7,15.9c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.1-0.6l5-5L3.4,8.3c-0.2-0.2-0.2-0.5,0-0.7 c0,0,0,0,0,0l7.1-7.2c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3l3.6,3.6c0.2,0.2,0.3,0.5,0.3,0.9c-0.1,0.3-0.3,0.6-0.5,0.7 L9,8.7l2,2c0.1,0.1,0.2,0.3,0.1,0.4c0,0.2-0.1,0.3-0.3,0.4l-10,4.4C0.8,15.9,0.8,15.9,0.7,15.9z M4.5,7.9l1.8,1.8 c0.2,0.2,0.2,0.5,0,0.7c0,0,0,0,0,0l-4.2,3.9l7.7-3.5l-2-2C7.7,8.8,7.7,8.6,7.7,8.5c0-0.2,0.1-0.3,0.3-0.4l6.9-3.4l-3.6-3.6L4.5,7.9 z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/power.02f000a2.svg";
export { ForwardRef as ReactComponent };